let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("4ns5x")).then(() => parcelRequire('jG5jM'));